import { addDays, endOfDay, startOfWeek } from "date-fns";

export const formatWebsite = (website: string, limit: number) =>
    `${website.replace(/http:\/\/|https:\/\//, "").substring(0, limit)}${
        website.replace(/http:\/\/|https:\/\//, "").length >= limit ? "..." : ""
    }`;

export const ensureUrlProtocol = (url: string) =>
    /^https?:\/\//i.test(url) ? url : `https://${url}`;

// Week runs Sunday–Saturday so that Saturday drafts fall within the current-week window.
export const getCurrentWeekRange = (): { startOfWeek: Date; endOfWeek: Date } => {
    const start = startOfWeek(new Date(), { weekStartsOn: 0 });
    return { startOfWeek: start, endOfWeek: endOfDay(addDays(start, 6)) };
};
